<template v-if="elements.length > 1">
  <div class="mr-4 mb-0">
    <template v-if="idx !== 0">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" @click="!loading && moveArrayUp(elements, idx)">
            mdi-arrow-up
          </v-icon>
        </template>
        <span>{{ $t('views.netWorth.recipeModal.moveUp') }}</span>
      </v-tooltip>
    </template>
    <template v-if="idx !== elements.length - 1">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" @click="!loading && moveArrayDown(elements, idx)">
            mdi-arrow-down
          </v-icon>
        </template>
        <span>{{ $t('views.netWorth.recipeModal.moveDown') }}</span>
      </v-tooltip>
    </template>
  </div>
</template>

<script>
import { moveArrayUp, moveArrayDown } from '@/lib/utils/array.js'

export default {
  props: {
    idx: {
      type: Number,
      required: true,
    },
    elements: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    moveArrayUp,
    moveArrayDown,
  },
}
</script>
